export const getMaxPollOptionValue = ({ poll }) => {
    if (poll.count_collected_amount) {
        const maxValues = poll.options.map((option) => option.collected_amount, 0);
        return Math.max(...maxValues) || 1;
    } else {
        const maxValues = poll.options.map((option) => option.vote_count, 0);
        return Math.max(...maxValues) || 1;
    }
};
